export default __webpack_public_path__ + "static/media/photo--lg--ish-4.9960a66d.jpg";